export default __webpack_public_path__ + "static/media/element_22.227323c0.webp";